export const LOADING_ATTENDANCE = "LOADING_ATTENDANCE";
export const GET_ATTENDANCE_LIST = "GET_ATTENDANCE_LIST";
export const ADD_ATTENDANCE = "ADD_ATTENDANCE";
export const UPDATE_ATTENDANCE = "UPDATE_ATTENDANCE";
export const GET_ATTENDANCE_BYID = "GET_ATTENDANCE_BYID";
export const IMPORT_ATTENDANCE = "IMPORT_ATTENDANCE";